import { Pipe, PipeTransform } from '@angular/core';
import {Argument} from '@app/core/model/filtering/argument';
import {OrgItem, OrgItemType} from '@app/views/admin/application-settings/models/orgItem.model';
import {GetOrgUnitPathAttributeName} from '@app/views/admin/application-settings/models/mapping-rules.model';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

@Pipe({
    name: 'orgUnitNamePipe'
})
export class OrgUnitNamePipe implements PipeTransform {

    transform(argument: Argument, ouList: OrgItem[], dataSourceType: DataSourceType, propertyName: string, showFullName = true): any {
        const orgUnitPath = GetOrgUnitPathAttributeName(dataSourceType);
        const orgType = (propertyName === orgUnitPath) ? OrgItemType.OU : OrgItemType.GROUP;
        if (showFullName) {
            return OrgItem.getOrgName(argument.id, argument.name, orgType, dataSourceType);
        }

        const ouName = argument.name;
        let ou: OrgItem;
        if (!ouName) {
            ou = ouList.find((orgItem: OrgItem) => orgItem.identifier === argument.id);
        }

        return ouName ? ouName
            : ou ? ou.name : OrgItem.getOrgName(argument.id, argument.name, orgType, dataSourceType);
    }

}
